<div class="container-fluid">
  <div class="row">
    <div class="col-lg-4 offset-lg-4 col-md-6 offset-md-3 col-sm-8 offset-sm-2 account-created-form">
      <div class="central_logo"> <img class="img-fluid" alt="IPOS Central LOGO" /> </div>
      <div class= "card account_created_message">
        <div>
          <img class="created_acc_checkmark" alt="created acc check"/>
        </div>
        <div class="form_header" [innerHTML]="modalTitle">
        </div>
        <div class="message-desc">
          <span *ngIf="isAccountApproved" i18n="@@account-created.approval-msg">Thank you, {{firstName}}. Your account has been successfully created. Please log in using your credentials.</span>
          <div *ngIf="!isAccountApproved">
            <span  i18n="@@account-created.unapproval-msg">Thank you, {{firstName}}. Your request for an account has been made and will be
              reviewed by an admin within 24 hours.</span>
            <div class="mt-2">              
              <span i18n="@@account-created.support-contact-msg">For any urgent needs - <div>Please contact your local Intel representative</div></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
